/**
 * Irish Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const ga: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Deais',
  'nav.funds': 'Cistí',
  'nav.investments': 'Infheistíochtaí',
  'nav.investees': 'Infheistithe',
  'nav.esg': 'ESG Athbhreithniú',
  'nav.compliance': 'Comhlíonadh',
  'nav.reports': 'Tuairiscí',
  'nav.settings': 'Socruithe',
  'nav.users': 'Úsáideoirí',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Táscairí',
  'nav.taxonomy': 'Tacsanomaíocht AE',
  'nav.filings': 'Comhduithe',
  'nav.calendar': 'Féilire',
  'nav.submit': 'Cuir sonraí isteach',
  'nav.submissions': 'Mo chuid aighneachtaí',
  'nav.benchmarks': 'Tagarmharcanna',
  'nav.messages': 'Teachtaireachtaí',
  'nav.portfolio': 'Punann',
  'nav.performance': 'Feidhmíocht cistí',
  'nav.esgSummary': 'ESG Achoimre',
  'nav.pipeline': 'Píblíne',
  'nav.dueDiligence': 'Dícheall cuí',
  'nav.impact': 'Méadracht tionchair',
  'nav.sdg': 'Mapáil SFI',
  'nav.audit': 'Rian iniúchta',
  'nav.snapshots': 'Grianghraif sonraí',
  'nav.knowledgeGraph': 'Graf eolais',
  'nav.geographic': 'Geografach',
  'nav.bi': 'BI Stiúideo',
  'nav.ai': 'AI Cúntóir',
  'nav.tasks': 'Tascanna',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Monatóir rialála',

  // Common Actions
  'action.create': 'Cruthaigh',
  'action.edit': 'Cuir in eagar',
  'action.delete': 'Scrios',
  'action.save': 'Sábháil',
  'action.cancel': 'Cealaigh',
  'action.submit': 'Cuir isteach',
  'action.approve': 'Faomh',
  'action.reject': 'Diúltaigh',
  'action.download': 'Íoslódáil',
  'action.export': 'Easpórtáil',
  'action.import': 'Iompórtáil',
  'action.filter': 'Scag',
  'action.search': 'Cuardaigh',
  'action.refresh': 'Athnuaigh',
  'action.close': 'Dún',
  'action.back': 'Ar ais',
  'action.next': 'Ar aghaidh',
  'action.previous': 'Roimhe seo',
  'action.viewAll': 'Féach ar fad',
  'action.viewDetails': 'Féach ar shonraí',
  'action.generate': 'Gin',
  'action.signOut': 'Sínigh amach',
  'action.addNew': 'Cuir nua leis',
  'action.invite': 'Tabhair cuireadh',

  // Statuses
  'status.draft': 'Dréacht',
  'status.submitted': 'Curtha isteach',
  'status.validated': 'Bailíochtaithe',
  'status.approved': 'Faofa',
  'status.rejected': 'Diúltaithe',
  'status.pending': 'Ar feitheamh',
  'status.inProgress': 'Ar siúl',
  'status.overdue': 'Thar téarma',
  'status.compliant': 'Comhlíontach',
  'status.filed': 'Comhdaithe',
  'status.active': 'Gníomhach',
  'status.inactive': 'Neamhghníomhach',
  'status.closed': 'Dúnta',
  'status.fundraising': 'Tiomsú airgid',
  'status.investing': 'Ag infheistiú',
  'status.harvesting': 'Ag baint',
  'status.validating': 'Ag bailíochtú',
  'status.review': 'Faoi athbhreithniú',
  'status.monitoring': 'Monatóireacht',
  'status.exiting': 'Ag imeacht',
  'status.pipeline': 'Píblíne',
  'status.due_diligence': 'Dícheall cuí',
  'status.disbursed': 'Eisíoctha',
  'status.restructured': 'Athstruchtúraithe',
  'status.matured': 'Aibí',
  'status.written_off': 'Díscríofa',
  'status.exited': 'Imithe',
  'status.incomplete': 'Neamhiomlán',
  'status.open': 'Oscailte',
  'status.in_progress': 'Ar siúl',
  'status.completed': 'Críochnaithe',
  'status.cancelled': 'Cealaithe',
  'status.accepted': 'Glactha',
  'status.failed': 'Theip air',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Forbhreathnú punainne',
  'dashboard.complianceStatus': 'Stádas comhlíonta',
  'dashboard.collectionProgress': 'Dul chun cinn bailithe',
  'dashboard.activityFeed': 'Gníomhaíocht',
  'dashboard.quickActions': 'Gníomhartha tapa',
  'dashboard.investmentPipeline': 'Píblíne infheistíochta',
  'dashboard.totalFunds': 'Cistí iomlána',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Infheistíochtaí gníomhacha',
  'dashboard.totalInvestees': 'Infheistithe',
  'dashboard.recentActivity': 'Gníomhaíocht le déanaí',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Iomlán tiomanta',
  'lp.capitalCalled': 'Caipiteal glaoite',
  'lp.distributed': 'Dáilte',
  'lp.netPosition': 'Glansuíomh',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Feidhmíocht cistí',
  'lp.esgSummary': 'ESG Achoimre',
  'lp.reportLibrary': 'Leabharlann tuairiscí',
  'lp.taxonomyAligned': 'Ailínithe le tacsanomaíocht',
  'lp.paiCoverage': 'PAI Clúdach',
  'lp.portfolioPerformance': 'Feidhmíocht punainne LP',

  // Fund Labels
  'fund.name': 'Ainm an chiste',
  'fund.code': 'Cód an chiste',
  'fund.vintage': 'Bliain bhunaithe',
  'fund.size': 'Méid an chiste',
  'fund.targetSize': 'Spriocmhéid',
  'fund.currency': 'Airgeadra',
  'fund.strategy': 'Straitéis',
  'fund.status': 'Stádas',
  'fund.sfdrCategory': 'SFDR Catagóir',
  'fund.geographyFocus': 'Fócas geografach',
  'fund.sectorFocus': 'Fócas earnála',

  // Form Labels
  'form.name': 'Ainm',
  'form.email': 'Ríomhphost',
  'form.country': 'Tír',
  'form.amount': 'Méid',
  'form.currency': 'Airgeadra',
  'form.date': 'Dáta',
  'form.description': 'Cur síos',
  'form.notes': 'Nótaí',
  'form.type': 'Cineál',
  'form.period': 'Tréimhse',
  'form.year': 'Bliain',
  'form.required': 'Riachtanach',
  'form.optional': 'Roghnach',

  // Table Headers
  'table.fund': 'Ciste',
  'table.commitment': 'Gealltanas',
  'table.called': 'Glaoite',
  'table.distributed': 'Dáilte',
  'table.tvpi': 'TVPI',
  'table.status': 'Stádas',
  'table.regulation': 'Rialachán',
  'table.filingType': 'Cineál comhdaithe',
  'table.reportingPeriod': 'Tréimhse',
  'table.createdAt': 'Cruthaithe',
  'table.actions': 'Gníomhartha',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Tacsanomaíocht AE',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Iomláine sonraí',
  'compliance.nextDeadline': 'An chéad spriocdháta eile',

  // Reports
  'report.quarterly': 'Tuairisc ráithiúil',
  'report.annual': 'Tuairisc bhliantúil',
  'report.paiStatement': 'PAI Ráiteas',
  'report.taxonomyReport': 'Tuairisc tacsanomaíochta',
  'report.generatedAt': 'Ginte',
  'report.version': 'Leagan',

  // General
  'general.loading': 'Ag lódáil...',
  'general.noData': 'Níl aon sonraí ar fáil',
  'general.error': 'Tharla earráid',
  'general.retry': 'Bain triail eile as',
  'general.total': 'Iomlán',
  'general.page': 'Leathanach',
  'general.of': 'as',
  'general.showing': 'Ag taispeáint',
  'general.results': 'torthaí',
  'general.language': 'Teanga',
  'general.english': 'Béarla',
  'general.french': 'Fraincis',

  // Tour
  'tour.takeTour': 'Dean turas',
  'tour.skip': 'Sceipeail',
  'tour.next': 'Ar aghaidh',
  'tour.prev': 'Siar',
  'tour.finish': 'Criochnaigh',


  // Tour Content, Form Labels, Table Headers, Actions, Errors (i18n wiring)
  'tour.sidebarTitle': 'Nascleanúint',
  'tour.sidebarContent': 'Úsáid an barra taoibh chun nascleanúint a dhéanamh idir bainistíocht punainne, bailiú sonraí ESG, comhlíonadh, tuairiscí agus uirlisí faisnéise.',
  'tour.kpisTitle': 'Forbhreathnú Punainne',
  'tour.kpisContent': 'Taispeánann na cártaí seo do phunann d\'amharc amháin — cistí iomlána, AUM, infheistíochtaí gníomhacha, agus líon na n-infheistithe.',
  'tour.actionsTitle': 'Gníomhartha Tapa',
  'tour.actionsContent': 'Cruthaigh cistí, cuir infheistíochtaí leis, tabhair cuireadh d\'infheistithe, agus gin tuairiscí le cliceáil amháin.',
  'tour.languageTitle': 'Teanga',
  'tour.languageContent': 'Athraigh idir 24 teanga oifigiúla AE. Aistrítear an comhéadan iomlán láithreach.',
  'tour.aiTitle': 'Cúntóir AI',
  'tour.aiContent': 'Cuir ceisteanna faoi do phunann am ar bith. Tá comhthéacs iomlán ag an gcúntóir AI faoi do chistí agus d\'infheistíochtaí.',
  'action.createFund': 'Cruthaigh Ciste',
  'action.editFund': 'Cuir Ciste in Eagar',
  'action.addInvestment': 'Cuir Infheistíocht Leis',
  'action.addInvestee': 'Cuir Infheistithe Leis',
  'action.editInvestee': 'Cuir Infheistithe in Eagar',
  'action.createTemplate': 'Cruthaigh Teimpléad',
  'action.createSubmission': 'Cruthaigh Aighneacht',
  'action.createFiling': 'Cruthaigh Comhdú',
  'action.generateReport': 'Gin Tuairisc',
  'action.inviteUser': 'Tabhair Cuireadh d\'Úsáideoir',
  'action.sendInvitation': 'Seol Cuireadh',
  'action.saveChanges': 'Sábháil Athruithe',
  'form.fundName': 'Ainm an Chiste',
  'form.fundCode': 'Cód Ciste',
  'form.sfdrCategory': 'Catagóir SFDR',
  'form.baseCurrency': 'Bunairgeadra',
  'form.targetSize': 'Méid Sprice',
  'form.vintageYear': 'Bliain Bhunaithe',
  'form.geographyFocus': 'Fócas Tíreolaíoch',
  'form.sectorFocus': 'Fócas Earnála',
  'form.investmentCode': 'Cód Infheistíochta',
  'form.instrumentType': 'Cineál Ionstraime',
  'form.maturityDate': 'Dáta Aibíochta',
  'form.sector': 'Earnáil',
  'form.countryCode': 'Cód Tíre',
  'form.entityType': 'Cineál Eintitis',
  'form.region': 'Réigiún',
  'form.staffCount': 'Líon Foirne',
  'form.borrowers': 'Iasachtaithe',
  'form.contactName': 'Ainm Teagmhála',
  'form.contactEmail': 'Ríomhphost Teagmhála',
  'form.templateName': 'Ainm an Teimpléid',
  'form.templateType': 'Cineál Teimpléid',
  'form.indicators': 'Táscairí',
  'form.reportingPeriod': 'Tréimhse Tuairiscithe',
  'form.reportingYear': 'Bliain Tuairiscithe',
  'form.regulation': 'Rialachán',
  'form.filingType': 'Cineál Comhdaithe',
  'form.reportType': 'Cineál Tuairisce',
  'form.emailAddress': 'Seoladh Ríomhphoist',
  'form.role': 'Ról',
  'form.selectFund': 'Roghnaigh ciste...',
  'form.selectInvestee': 'Roghnaigh infheistithe...',
  'table.code': 'Cód',
  'table.investee': 'Infheistithe',
  'table.instrument': 'Ionstraim',
  'table.amount': 'Méid',
  'table.currency': 'Airgeadra',
  'table.maturity': 'Aibíocht',
  'table.name': 'Ainm',
  'table.country': 'Tír',
  'table.type': 'Cineál',
  'table.period': 'Tréimhse',
  'table.completion': 'Comhlánú',
  'table.submitted': 'Curtha isteach',
  'table.version': 'Leagan',
  'table.indicators': 'Táscairí',
  'table.dueDate': 'Dáta Dlite',
  'table.generated': 'Ginte',
  'table.email': 'Ríomhphost',
  'table.role': 'Ról',
  'error.createFailed': 'Theip ar chruthú. Bain triail as arís.',
  'error.updateFailed': 'Theip ar nuashonrú. Bain triail as arís.',
  'error.loadFailed': 'Theip ar luchtú sonraí.',

  // Sidebar Sections
  'sections.portfolio': 'PUNANN',
  'sections.dataCollection': 'BAILIÚ SONRAÍ',
  'sections.intelligence': 'FAISNÉIS',
  'sections.ecosystem': 'ÉICEACHÓRAS',
  'sections.admin': 'RIARACHÁN',
  'sections.other': 'EILE',

  // Page Titles
  'pages.messagesTitle': 'Teachtaireachtaí',
  'pages.taxonomyTitle': 'Tacsanomaíocht AE',
  'pages.biStudioTitle': 'BI Studio',
  'pages.knowledgeGraphTitle': 'Graf Eolais',
  'pages.benchmarksTitle': 'Tagarmharcanna',
  'pages.mcpTitle': 'Comhtháthú MCP',
  'pages.tasksTitle': 'Tascanna',
  'pages.submitDataTitle': 'Cuir sonraí ESG isteach',

  // Empty States
  'empty.benchmarksComingSoon': 'Tagarmharcanna ag teacht go luath',

  // Labels
  'labels.sfdr': 'SFDR',
  'labels.euTaxonomy': 'Tacsanomaíocht AE',
  'labels.csrd': 'CSRD',
  'labels.mifid': 'MiFID',
  'labels.other': 'Eile',
  'labels.critical': 'Criticiúil',
  'labels.high': 'Ard',
  'labels.medium': 'Meánach',
  'labels.low': 'Íseal',

  // Count / summary strings
  'count.fundsTotal': '{count} fund(s) total',
  'count.investmentsTotal': '{count} investment(s) total',
  'count.investeesTotal': '{count} investee(s) total',

  // Filter options
  'filter.allStatus': 'All Status',
  'filter.allSfdr': 'All SFDR',

  // Empty states
  'empty.noFundsYet': 'No funds yet. Create your first fund.',
  'empty.noFundsMatch': 'No funds match your filters.',
  'empty.noInvestmentsYet': 'No investments yet.',
  'empty.noInvestmentsMatch': 'No investments match your search.',
  'empty.noInvesteesYet': 'No investees yet.',
  'empty.noInvesteesMatch': 'No investees match your search.',
  'empty.noTemplatesYet': 'No ESG templates configured yet.',
  'empty.noSubmissionsYet': 'No ESG submissions yet.',
  'empty.noComplianceData': 'No SFDR compliance data available.',
  'empty.noFilingsYet': 'No compliance filings yet.',
  'empty.noReportsYet': 'No reports generated yet.',
  'empty.selectFundPai': 'Select a fund to view PAI indicators.',
  'empty.noPaiIndicators': 'No PAI indicators found for this fund.',
  'empty.selectFundCalendar': 'Select a fund to view compliance calendar.',
  'empty.noCalendarEvents': 'No upcoming events for this fund.',

  // Page subtitles
  'subtitle.esg': 'Templates and data submissions',
  'subtitle.compliance': 'SFDR, PAI indicators, and regulatory filings',
  'subtitle.reports': 'Generate and manage compliance reports',
  'subtitle.settings': 'Manage your account and preferences',

  // Tab labels
  'tab.templates': 'Templates',
  'tab.submissions': 'Submissions',
  'tab.sfdr': 'SFDR',
  'tab.paiIndicators': 'PAI Indicators',
  'tab.filings': 'Filings',
  'tab.reports': 'Reports',
  'tab.calendar': 'Calendar',

  // Compliance table headers
  'table.indicator': 'Indicator',
  'table.category': 'Category',
  'table.metric': 'Metric',
  'table.value': 'Value',
  'table.mandatory': 'Mandatory',
  'table.data': 'Data',
  'table.deadline': 'Deadline',
  'table.taxonomy': 'Taxonomy',

  // Yes/No
  'general.yes': 'Yes',
  'general.no': 'No',

  // Error messages
  'error.loadTemplates': 'Failed to load templates.',
  'error.loadSubmissions': 'Failed to load submissions.',
  'error.loadCompliance': 'Failed to load compliance data.',
  'error.loadPai': 'Failed to load PAI indicators.',
  'error.loadFilings': 'Failed to load filings.',
  'error.loadCalendar': 'Failed to load calendar events.',
  'error.createTemplate': 'Failed to create template. Please try again.',
  'error.createSubmission': 'Failed to create submission. Please try again.',
  'error.createFiling': 'Failed to create filing. Please try again.',
  'error.generateReport': 'Failed to generate report.',
  'error.templateNameRequired': 'Template name is required',
  'error.selectFund': 'Select a fund',
  'error.selectInvestee': 'Select an investee',
  'error.validAmount': 'Enter a valid amount',
  'error.reportingPeriodRequired': 'Reporting period is required',
  'error.validYearRequired': 'Valid year is required',
  'error.enterPeriod': 'Enter a period',
  'error.nameRequired': 'Name is required',
  'error.countryCodeRequired': 'Country code is required',
  'error.operationFailed': 'Operation failed.',
  'error.pleaseselectFund': 'Please select a fund',

  // Success messages
  'success.submissionCreated': 'Submission created successfully.',
  'success.profileSaved': 'Profile saved successfully.',

  // Relative time
  'time.justNow': 'Just now',
  'time.minutesAgo': '{count}m ago',
  'time.hoursAgo': '{count}h ago',
  'time.daysAgo': '{count}d ago',

  // Settings
  'settings.profile': 'Profile',
  'settings.organization': 'Organization',
  'settings.apiKeys': 'API Keys',
  'settings.notifications': 'Notifications',
  'settings.orgId': 'Org ID',
  'settings.tier': 'Tier',
  'settings.apiKeysDescription': 'Contact your organization administrator to manage API keys and integration credentials.',
  'settings.apiKeysNote': 'API keys provide programmatic access to Impact Core data. For security, key creation and revocation is restricted to organization admins.',
  'settings.notifReportAlerts': 'Report generation alerts',
  'settings.notifReportAlertsDesc': 'Email when a report is generated or fails',
  'settings.notifComplianceReminders': 'Compliance deadline reminders',
  'settings.notifComplianceRemindersDesc': 'Email reminders for upcoming filing deadlines',
  'settings.notifEsgUpdates': 'ESG submission updates',
  'settings.notifEsgUpdatesDesc': 'Email when investee submissions change status',
  'settings.notifInAppActivity': 'In-app activity feed',
  'settings.notifInAppActivityDesc': 'Show real-time activity notifications in header',

  // Data Completeness label
  'compliance.dataCompletenessLabel': 'Data Completeness',
};
